import React, { useState } from 'react';

import PageTabs from 'ui/PageTabs';

export default ({ context, onAction }) => {
    const [tab, setTab] = useState(0);
    const {
        components: { SettingsTabView, CompanyMappingTabView },
    } = context;
    const tabs = [
        {
            label: 'Settings',
            name: 'settings',
            component: SettingsTabView,
        },
        {
            label: 'Company Mapping',
            name: 'company-mapping',
            component: CompanyMappingTabView,
        },
    ];
    const onTabChange = tab => setTab(tab);
    return (
        <PageTabs
            tabs={tabs.map(tab => tab.label)}
            current={tab}
            onChange={onTabChange}
            secondary
        >
            {() => {
                const Component = tabs[tab].component;
                if (Component) {
                    return <Component context={context} onAction={onAction} />;
                }
            }}
        </PageTabs>
    );
};
